import * as actionTypes from "../Action/ActionTypes";

const initialState = {
  scheduleInterviewEStatus: false,
  verifyEmailStatus: null,
  errorMsgVerifyEmail: "",
  VerifyEmailNetworkStatus: false,
  initial: true,
  ErrorCode: "",
  loginStatus: false,
  signUpStatus: false,
  loginErrorMsg: "",
  signUpErrorMsg: "",
  signUpErrorMsgStatus: false,
  signUpExtErr: "",
  signUpExtErrStatus: false,
  loader: false,
  signUpLoader: false,
  feedbackLoader: false,
  emailLinkSentSuccess: false,
  emailLinkSentLoader: false,
  resetLinkErrorMsg: "",
  updateCompanyLocationErrorMsg: "",
  updateCompanyLocationLoader: false,
  updateCompanyLocationSuccess: false,
  countryArr: [],
  stateArr: [],
  profileData: null,
  cityArr: [],
  resetErrorMsg: "",
  resetPassword: false,
  resetLoader: false,
  emailForgot: "",
  jobProfileDetails: [],
  records: 0,
  createJobProfile: "",
  verifyStatus: true,
  verifyOtp: false,
  verifyOtpMessage: "",
  otploader: false,
  createCandidateErrorMsg: "",
  searchNoResults: false,
  candidateSearchNoResults: false,

  resendEmailStatus: false,
  resendEmailErrorMsg: "",
  resendEmailLoader: false,
  resendEmailErrorStatus: false,

  candidateFeedback: {},
  interviewFeedback: {},
  skillRating: {},
  feedBackErr: false,

  getInterviewListStatus: false,
  interviewList: null,
  pagination: 0,
  getInterviewListLoader: false,
  errorMsg: "",
  getInterviewListNetworkStatus: false,

  cancelInterviewError: false,
  cancelInterviewErrorMsg: "",
  cancelInterviewSuccess: false,

  skillLoader: false,
  scheduleInterviewJobProfileList: [],
  scheduleInterviewJobProfileError: false,
  scheduleInterviewJobProfileNodata: false,
  serverErrorStatus: false,
  singleJobProfileDetails: [],
  scheduleInterviewCandidateList: [],
  scheduleInterviewCandidateNodata: false,
  SchedulecandidateRecords: 0,
  singleCandidateProfileDetails: [],
  scheduleInterviewInterviewerList: null,
  scheduleInterviewInterviewerNodata: false,
  candidateProfileDetails: [],
  candidateRecords: 0,

  scheduleJobNoResults: false,
  scheduleCandidateNoResults: false,

  skillList: [],

  getdashBoardStatus: false,
  dashBoardList: null,
  dashBoardPagination: 0,
  getdashBoardLoader: false,
  dashBoarderrorMsg: "",

  getExtInterviewListStatus: false,
  ExtinterviewerList: null,
  Extpagination: 0,
  getExtInterviewerLoader: false,
  ExterrorMsg: "",

  scheduleInterviewLoader: false,
  scheduleInterviewErrorMsg: "",

  interviewerProfileLoader: false,
  interviewerProfileStatus: false,
  interviewerProfileData: null,
  interviewerProfileErrorMsg: " ",

  saveInterviewerRatingLoader: false,
  saveInterviewerRatingStatus: false,
  saveInterviewerRatingErrorMsg: "",

  openCvLoader: false,
  openCvStatus: false,
  openCvErrorMsg: "",
  openCvSuggestion: "",
  cvData: null,

  candidate_download_loader: false,
  candidate_download_status: false,
  candidate_cv_data: null,
  candidate_download_err_msg: "",

  resendotpLoader: false,
  otpSent: null,
  mobileLastFourDigit: "",
  resendotpApiStatus: false,
  resentNetworkError: false,

  verifyotpAtloginLoader: false,
  verifyotpAtloginApiStatus: false,
  verifyotpAtloginNetworkError: false,
  verifyotpAtloginerrorMsg: "",

  resendInterviewerEmailStatus: "",
  resendInterviewerEmailLoader: false,
  myProfileErrorStatus: false,

  paymentInitiateLoader: false,
  paymentInitiateData: null,
  paymentInitiateNetworkError: false,
  paymentInitiateError: false,
  paymentInitiateErrorMsg: null,

  InterviewPaymentListLoader: false,
  InterviewPaymentListData: null,
  InterviewPaymentListNetworkError: false,
  InterviewPaymentListError: false,
  InterviewPaymentListErrorMsg: null,

  candidateMultipleFeedbacksList: [],
  candidateMultipleFeedbacksError: false,
  candidateMultipleFeedbacksErrorMsg: "",

  MakePaymentLoader: false,
  MakePaymentData: null,
  MakePaymentNetworkError: false,
  MakePaymentError: false,
  MakePaymentErrorMsg: null,

  encRequest: "",
  access_code: "",
  securityDepositErr: false,
  securityDepositErrMsg: "",
  securityDepositServerErr: false,

  paymentfornonadminLoader: true,
  paymentfornonadminApiStatus: false,
  paymentfornonadminTotalcount: "",
  paymentfornonadminpaymentListData: null,
  paymentListDataNetworkError: false,
  checkInterviewBalanceError: false,
  checkInterviewBalanceErrorMsg: "",
  checkInterviewBalanceNetworkError: false,
  sufficientBalance: false,
  remainingBalance: 0,

  confirmPaymentLoader: true,
  confirmPaymentError: false,
  confirmPaymentErrorMsg: "",
  confirmPaymentStatusData: null,
  confirmPaymentNetworkError: false,
  PaymentInvoiceListLoader: false,
  PaymentInvoiceListData: null,
  PaymentInvoiceListNetworkError: false,
  PaymentInvoiceListError: false,
  PaymentInvoiceListErrorMsg: null,

  PaymentInvoiceDetailsLoader: false,
  PaymentInvoiceDetailsData: null,
  PaymentInvoiceDetailsNetworkError: false,
  PaymentInvoiceDetailsError: false,
  PaymentInvoiceDetailsErrorMsg: null,

  OrderHistoryLoader: false,
  OrderHistoryData: null,
  OrderHistoryNetworkError: false,
  OrderHistoryError: false,
  OrderHistoryErrorMsg: null,

  beforepaymentinvoiceLoader: false,
  beforepaymentinvoiceNetworkError: false,
  beforepaymentinvoiceApistatus: false,
  beforepaymentinvoiceData: "",

  availableSlotLoader: false,
  availableSlotData: null,
  availableSlotNetworkError: false,
  availableSlotError: false,
  availableSlotErrorMsg: null,

  empresetLoader: false,
  empresetSuccess: false,
  empresetErrorMsg: null,

  notifyFoxmatrixLoader: false,
  notifyFoxmatrixSuceess: false,
  notifyFoxmatrixFailMsg: false,
  notifyFoxmatrixNetworkError: false,

  viewInterviewDetailsLoader: false,
  viewInterviewDetailsData: null,
  viewInterviewDetailsFailMsg: false,
  viewInterviewDetailsNetworkError: false,

  getInterviewerTimeSlotsLoader: true,
  myScheduleTimingResponseList: null,
  interviewerAvailableSlotResponseList: null,
  getInterviewerTimeSlotsFailMsg: false,
  getInterviewerTimeSlotsNetworkError: false,

  mobileUpdated: null,
  mobileUpdatedError: null,
  otpUpdated: null,
  otpUpdatedError: null,
  nameUpdated: null,
  nameUpdatedError: null,

  mobileUpdatedLoader: false,
  otpUpdatedLoader: false,

  creditBalance: null,

  availabilityFilter: "",
  typeDate: "",
  timeslotFilter: "",
  nameFilter: "",
};

export const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_INITIAL:
      return {
        ...state,
        loginErrorMsg: "",
        loader: true,
        loginStatus: false,
        initial: true,
      };
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loginStatus: action.payload,
        loginErrorMsg: "",
        loader: false,
        initial: true,
      };
    case actionTypes.LOGIN_FAIL:
      console.log(action.payload, "dfdf");
      return {
        ...state,
        loginStatus: false,
        loginErrorMsg: action.payload,
        loader: false,
        initial: false,
        ErrorCode: action.ErrorCode,
      };

    case actionTypes.CANDIDATE_SUCCESS:
      return {
        ...state,
        loginStatus: action.payload,
        loginErrorMsg: "",
        loader: false,
        initial: true,
      };
    case actionTypes.CANDIDATE_FAIL:
      return {
        ...state,
        loginStatus: false,
        loginErrorMsg: action.payload,
        loader: false,
        initial: false,
        ErrorCode: action.ErrorCode,
      };
    case actionTypes.CLEAR_LOGIN_STATE:
      return {
        ...state,

        loader: false,
        loginStatus: false,
        ErrorCode: "",
      };
    case actionTypes.SIGNUP_INITIAL:
      return {
        ...state,
        signUpErrorMsgStatus: false,
        signUpErrorMsg: "",
        signUpLoader: true,
        signUpExtErrStatus: false,
        signUpExtErr: "",
        signUpStatus: false,
      };

    case actionTypes.SIGNUP_SUCCESS:
      return {
        ...state,
        signUpStatus: true,
        signUpErrorMsgStatus: false,
        signUpExtErrStatus: false,
        signUpErrorMsg: "",
        signUpLoader: false,
      };
    case actionTypes.SIGNUP_FAIL:
      return {
        ...state,
        signUpStatus: false,
        signUpErrorMsgStatus: true,
        signUpExtErrStatus: false,
        signUpErrorMsg: action.payload,
        signUpLoader: false,
      };
    case actionTypes.SIGNUP_EXT_ERROR:
      return {
        ...state,
        signUpStatus: false,
        signUpLoader: false,
        signUpExtErrStatus: true,
        signUpErrorMsgStatus: false,
        signUpExtErr: action.payload,
      };
    case actionTypes.RESEND_SIGNUP_EMAIL_INITIAL:
      return {
        ...state,
        resendEmailErrorStatus: false,
        resendEmailLoader: true,
        resendEmailStatus: false,
        resendEmailErrorMsg: "",
      };

    case actionTypes.RESEND_SIGNUP_EMAIL_SUCCESS:
      return {
        ...state,
        resendEmailErrorStatus: false,
        resendEmailLoader: false,
        resendEmailStatus: true,
        resendEmailErrorMsg: "",
      };
    case actionTypes.RESEND_SIGNUP_EMAIL_FAIL:
      return {
        ...state,
        resendEmailErrorStatus: true,
        resendEmailLoader: false,
        resendEmailStatus: false,
        resendEmailErrorMsg: action.payload,
      };
    case actionTypes.GET_COUNTRY_SUCCESS:
      return {
        ...state,
        countryArr: action.payload,
        cityArr: "",
      };
    case actionTypes.GET_STATE_SUCCESS:
      return {
        ...state,

        cityArr: "",
      };
    case actionTypes.GET_STATE_FAIL:
      return {
        ...state,
        stateStatus: false,

        cityArr: "",
        stateErrorMsg: action.payload,
      };
    case actionTypes.GET_CITY_SUCCESS:
      return {
        ...state,
        cityArr: action.payload,
      };
    case actionTypes.GET_CITY_FAIL:
      return {
        ...state,
        cityStatus: false,

        cityErrorMsg: action.payload,
      };
    case actionTypes.FORGOT_PASSWORD_LINK_INITIAL:
      return {
        ...state,
        resetLinkErrorMsg: "",
        emailLinkSentLoader: true,
      };
    case actionTypes.FORGOT_PASSWORD_LINK_SUCCESS:
      return {
        ...state,
        emailLinkSentSuccess: true,
        resetLinkErrorMsg: "",
        emailLinkSentLoader: false,
        emailForgot: action.email,
        resend: action.resend,
      };
    case actionTypes.FORGOT_PASSWORD_LINK_FAIL:
      return {
        ...state,
        emailLinkSentSuccess: false,
        resetLinkErrorMsg: "Account does not exist",
        emailLinkSentLoader: false,
      };
    case actionTypes.FORGOT_PASSWORD_SECOND_SCREEN_HIDE:
      return {
        ...state,
        emailLinkSentSuccess: false,
        resetLinkErrorMsg: "",
        emailLinkSentLoader: false,
      };
    case actionTypes.FORGOT_PASSWORD_NETWORK_ERROR:
      return {
        ...state,
        emailLinkSentSuccess: false,
        resetLinkErrorMsg: "Network Error !! Some things went Wrong",
        emailLinkSentLoader: false,
      };
    case actionTypes.UPDATE_COMPANY_LOCATION_INITIAL:
      return {
        ...state,
        updateCompanyLocationSuccess: false,
        updateCompanyLocationLoader: true,
        updateCompanyLocationErrorMsg: "",
      };
    case actionTypes.UPDATE_COMPANY_LOCATION_SUCCESS:
      return {
        ...state,
        updateCompanyLocationSuccess: true,
        updateCompanyLocationLoader: false,
        updateCompanyLocationErrorMsg: "",
      };
    case actionTypes.UPDATE_COMPANY_LOCATION_FAIL:
      return {
        ...state,
        updateCompanyLocationSuccess: false,
        updateCompanyLocationLoader: false,
        updateCompanyLocationErrorMsg: action.payload,
      };
    case actionTypes.MYPROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        updateStatus: false,
        verifyOtp: false,
        mobileStatus: false,
        myProfileErrorStatus: false,
      };
    case actionTypes.MYPROFILE_SUCCESS:
      return {
        ...state,
        profileData: action.payload,
        loader: false,
        updateStatus: false,
        myProfileErrorStatus: false,
      };
    case actionTypes.MYPROFILE_FAIL:
      return {
        ...state,
        loader: false,
        updateStatus: false,
        myProfileErrorStatus: false,
      };
    case actionTypes.MYPROFILE_SERVER_ERROR:
      return {
        ...state,
        loader: false,
        updateStatus: false,
        myProfileErrorStatus: true,
      };

    case actionTypes.RESET_PASSWORD_INITIAL:
      return {
        ...state,
        resetLoader: true,
        resetErrorMsg: "",
      };

    case actionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPassword: true,
        resetLoader: false,
        resetErrorMsg: "",
      };

    case actionTypes.RESET_PASSWORD_FAIL:
      return {
        ...state,
        resetPassword: false,
        resetLoader: false,
        resetErrorMsg: "Link Expired",
      };
    case actionTypes.UPDATE_MYPROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        updateStatus: false,
        mobileStatus: false,
        verifyOtp: false,
      };
    case actionTypes.UPDATE_MYPROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        updateStatus: action.updateStatus,
        mobileStatus: action.mobileStatus,
      };
    case actionTypes.UPDATE_MYPROFILE_FAIL:
      return {
        ...state,
        loader: false,
        updateStatus: false,
        mobileStatus: false,
      };
    case actionTypes.VIEW_JOB_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        loginErrorMsg: "",
        serverErrorStatus: false,
        noDataStatus: false,
      };
    case actionTypes.VIEW_JOB_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        jobProfileDetails: action.payload,
        records: action.records,
        loginErrorMsg: "",
        serverErrorStatus: false,
        noDataStatus: false,
        searchNoResults: false,
      };
    case actionTypes.VIEW_JOB_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        jobProfileDetails: [],
        serverErrorStatus: action.payload,
        noDataStatus: action.nodata,
        searchNoResults: false,
      };
    case actionTypes.UPDATE_JOB_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        loginErrorMsg: "",
        updateErrorStatus: false,
      };
    case actionTypes.UPDATE_JOB_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        loginErrorMsg: "",
        updateErrorStatus: false,
      };
    case actionTypes.UPDATE_JOB_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        loginErrorMsg: action.payload,
        updateErrorStatus: true,
      };
    case actionTypes.UPDATE_CANDIDATE_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        loginErrorMsg: "",
        candidateupdateErrorStatus: false,
      };
    case actionTypes.UPDATE_CANDIDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        loginErrorMsg: "",
        candidateupdateErrorStatus: false,
      };
    case actionTypes.UPDATE_CANDIDATE_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        loginErrorMsg: "",
        candidateupdateErrorStatus: true,
      };
    case actionTypes.UPDATE_CANDIDATE_PROFILE_NETWORK_ERROR:
      return {
        ...state,
        loader: false,
        loginErrorMsg: "",
        candidateupdateErrorStatus: true,
      };
    case actionTypes.CREATE_JOB_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        createErrorStatus: false,
      };
    case actionTypes.CREATE_JOB_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        createErrorStatus: false,
      };
    case actionTypes.CREATE_JOB_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        createErrorStatus: true,
      };
    case actionTypes.ARCHIVE_JOB_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        loginErrorMsg: "",
        archiveErrorStatus: false,
      };
    case actionTypes.ARCHIVE_JOB_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        loginErrorMsg: "",
        archiveErrorStatus: false,
      };
    case actionTypes.ARCHIVE_JOB_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        loginErrorMsg: action.payload,
        archiveErrorStatus: true,
      };
    case actionTypes.SEARCH_CANDIDATE_PROFILE_EMPTY:
      return {
        ...state,
        loader: false,
        candidatenoDataStatus: true,
        candidateSearchNoResults: true,
      };
    case actionTypes.GET_SKILLS_INITIAL:
      return {
        ...state,
        skillloader: true,
        loginErrorMsg: "",
      };
    case actionTypes.GET_SKILLS_SUCCESS:
      return {
        ...state,
        skillloader: false,
        skillList: action.payload,
        loginErrorMsg: "",
      };
    case actionTypes.GET_SKILLS_FAIL:
      return {
        ...state,
        skillloader: false,
        loginErrorMsg: action.payload,
      };
    case actionTypes.VERIFY_OTP_INITIAL:
      return {
        ...state,
        otploader: true,
        verifyOtp: false,
        verifyOtpMessage: "",
      };

    case actionTypes.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        otploader: false,
        verifyOtp: true,
        verifyOtpMessage: "",
      };
    case actionTypes.VERIFY_OTP_FAIL:
      return {
        ...state,
        otploader: false,
        verifyOtp: false,
        verifyOtpMessage: action.verifyerrmsg,
      };
    case actionTypes.VERIFY_OTP_RESET_STATE:
      return {
        ...state,
        verifyOtp: false,
        verifyOtpMessage: "",
        otploader: false,
      };
    case actionTypes.VERIFY_OTP_NETWORK_ERROR:
      return {
        ...state,
        otploader: false,
        verifyOtpMessage: "Network Error.",
      };

    case actionTypes.GETINTERVIEWLIST_INITIAL:
      return {
        ...state,
        getInterviewListLoader: true,
        getInterviewListNetworkStatus: false,
        cancelInterviewError: false,
        cancelInterviewSuccess: false,
      };
    case actionTypes.GETINTERVIEWLIST_SUCCESS:
      return {
        ...state,
        getInterviewListLoader: false,
        getInterviewListStatus: true,
        getInterviewListNetworkStatus: false,
        interviewList: action.interviewList,
        pagination: action.pagination,
      };
    case actionTypes.GETINTERVIEWLIST_FAIL:
      return {
        ...state,
        getInterviewListLoader: false,
        getInterviewListStatus: false,
        getInterviewListNetworkStatus: false,
        errorMsg: action.payload,
      };
    case actionTypes.GETINTERVIEWLIST_NETWORK_ERROR:
      return {
        ...state,
        getInterviewListLoader: false,
        getInterviewListStatus: false,
        getInterviewListNetworkStatus: true,
        errorMsg:
          "Our servers are not responding at the moment, Please bear with us.",
      };
    case actionTypes.VIEW_SINGLE_JOB_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        loginErrorMsg: "",
      };
    case actionTypes.VIEW_SINGLE_JOB_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        singleJobProfileDetails: action.payload,
        loginErrorMsg: "",
      };
    case actionTypes.VIEW_SINGLE_JOB_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        loginErrorMsg: action.payload,
      };
    case actionTypes.VIEW_SINGLE_CANDIDATE_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        loginErrorMsg: "",
      };
    case actionTypes.VIEW_SINGLE_CANDIDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        singleCandidateProfileDetails: action.payload,
        loginErrorMsg: "",
      };
    case actionTypes.VIEW_SINGLE_CANDIDATE_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        loginErrorMsg: action.payload,
      };
    case actionTypes.CREATE_CANDIDATE_INITIAL:
      return {
        ...state,
        loader: true,
        createCandidateErrorMsg: "",
        candidatecreateErrorStatus: false,
      };
    case actionTypes.CREATE_CANDIDATE_SUCCESS:
      return {
        ...state,
        loader: false,
        createErrorStatus: "",
        createCandidateErrorMsg: "",
        candidatecreateErrorStatus: false,
      };
    case actionTypes.CREATE_CANDIDATE_FAIL:
      return {
        ...state,
        loader: false,
        candidatecreateErrorStatus: true,
        createCandidateErrorMsg: action.payload,
      };
    case actionTypes.VIEW_CANDIDATE_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        candidateserverErrorStatus: false,
        candidatenoDataStatus: false,
      };
    case actionTypes.VIEW_CANDIDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        candidateProfileDetails: action.payload,
        candidateRecords: action.candidateRecords,

        candidateserverErrorStatus: false,
        candidatenoDataStatus: false,
        candidateSearchNoResults: false,
      };
    case actionTypes.VIEW_CANDIDATE_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        candidateProfileDetails: [],
        candidateserverErrorStatus: action.payload,
        candidatenoDataStatus: action.nodata,
        candidateSearchNoResults: false,
      };
    case actionTypes.ARCHIVE_CANDIDATE_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        loginErrorMsg: "",
        candidatearchiveErrorStatus: false,
      };
    case actionTypes.ARCHIVE_CANDIDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        loginErrorMsg: "",
        candidatearchiveErrorStatus: false,
      };
    case actionTypes.ARCHIVE_CANDIDATE_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        loginErrorMsg: "",
        candidatearchiveErrorStatus: true,
      };
    //Schedule Interview Job Listing Atishay Start
    case actionTypes.GET_JOB_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        loginErrorMsg: "",
        scheduleInterviewJobProfileError: false,
        scheduleInterviewJobProfileNodata: false,
        serverErrorStatus: false,
        scheduleInterviewEStatus: false, //Added here so that state become false after scheduling an interview so that popup msg not show again.
      };
    case actionTypes.GET_JOB_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        scheduleInterviewJobProfileList: action.payload,
        records: action.records,
        loginErrorMsg: "",
        scheduleInterviewJobProfileError: false,
        scheduleInterviewJobProfileNodata: false,
        serverErrorStatus: false,
        scheduleJobNoResults: false,
      };

    case actionTypes.GET_JOB_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        loginErrorMsg: action.payload,
        scheduleInterviewJobProfileError: true,
        scheduleInterviewJobProfileNodata: true,
        serverErrorStatus: action.payload,
        scheduleJobNoResults: false,
      };
    case actionTypes.GET_JOB_PROFILE_ERROR:
      return {
        ...state,
        loader: false,
        serverErrorStatus: true,
        scheduleInterviewJobProfileError: false,
        scheduleInterviewJobProfileNodata: false,
        loginErrorMsg: "Network Error !! Some things went Wrong",
      };
    case actionTypes.SEARCH_SCHEDULE_JOB_PROFILE_EMPTY:
      return {
        ...state,
        scheduleInterviewJobProfileNodata: true,
        scheduleJobNoResults: true,
        loader: false,
      };

    case actionTypes.SEARCH_JOB_PROFILE_EMPTY:
      return {
        ...state,
        noDataStatus: true,
        searchNoResults: true,
        loader: false,
      };
    //Schedule Interview Job Listing Atishay Ends

    case actionTypes.GETDASHBOARDDETAILS_INITIAL:
      return {
        ...state,
        getdashBoardLoader: true,
      };
    case actionTypes.GETDASHBOARDDETAILS_SUCCESS:
      return {
        ...state,
        getdashBoardLoader: false,
        getdashBoardStatus: true,
        dashBoardList: action.dashBoardList,
        dashBoardPagination: action.dashBoardPagination,
      };
    case actionTypes.GETDASHBOARDDETAILS_NETWORK_ERROR:
      return {
        ...state,
        getdashBoardLoader: false,
        getdashBoardStatus: false,
        dashBoarderrorMsg:
          "Our servers are not responding at the moment, Please bear with us.",
      };
    case actionTypes.GETDASHBOARDDETAILS_FAIL:
      return {
        ...state,
        getdashBoardLoader: false,
        getdashBoardStatus: false,
        dashBoarderrorMsg:
          "Our servers are not responding at the moment, Please bear with us.",
      };
    //SChedule Interview Candidate Listing Atishay Start
    case actionTypes.GET_CANDIDATE_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        loginErrorMsg: "",
        scheduleInterviewCandidateNodata: false,
        candidateserverErrorStatus: false,
      };
    case actionTypes.GET_CANDIDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        candiDateProfile: action.payload,
      };
    case actionTypes.GET_CANDIDATE_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        loginErrorMsg: action.payload,
        scheduleInterviewCandidateNodata: action.nodata,
        scheduleCandidateNoResults: false,
        candidateserverErrorStatus: action.payload,
      };

    case actionTypes.SEARCH_SCHEDULE_CANDIDATE_PROFILE_EMPTY:
      return {
        ...state,
        loader: false,
        scheduleInterviewCandidateNodata: true,
        scheduleCandidateNoResults: true,
      };
    //Schedule Interview Candidate Listing Atishay Ends
    //SChedule Interview Interviewer Listing Atishay Start
    case actionTypes.GET_INTERVIEWER_PROFILE_INITIAL:
      return {
        ...state,
        loader: true,
        loginErrorMsg: "",
        scheduleInterviewInterviewerList: null,
        serverErrorStatus: false,
        scheduleInterviewInterviewerNodata: false,
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_SUCCESS:
      return {
        ...state,
        loader: false,
        scheduleInterviewInterviewerList: action.payload,
        records: action.records,
        scheduleInterviewInterviewerNodata: false,
        serverErrorStatus: false,
        loginErrorMsg: "",
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_FAIL:
      return {
        ...state,
        loader: false,
        loginErrorMsg: action.payload,
        scheduleInterviewInterviewerNodata: true,
        serverErrorStatus: false,
      };
    //Schedule Interview Interviewer Listing Atishay Ends
    //Verify email
    case actionTypes.VERIFY_EMAIL_INITIAL:
      return {
        ...state,
        loader: true,
        verifyEmailStatus: false,
      };
    case actionTypes.VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        loader: false,
        verifyEmailStatus: action.payload,
      };
    case actionTypes.VERIFY_EMAIL_FAIL:
      return {
        ...state,
        loader: false,
        verifyEmailStatus: action.payload,
        errorMsgVerifyEmail: action.errorMsgVerifyEmail,
      };

    case actionTypes.VERIFY_EMAIL_NETWORK_ERROR:
      return {
        ...state,
        loader: false,
        VerifyEmailNetworkStatus: true,
      };

    case actionTypes.GET_EXT_INTERVIEWER_LIST_INITIAL:
      return {
        ...state,
        getExtInterviewerLoader: true,
      };
    case actionTypes.GET_EXT_INTERVIEWER_LIST_SUCCESS:
      return {
        ...state,
        getExtInterviewerLoader: false,
        getExtInterviewListStatus: true,
        ExtinterviewerList: action.ExtinterviewerList,
        Extpagination: action.Extpagination,
      };
    case actionTypes.GET_EXT_INTERVIEWER_LIST_FAIL:
      return {
        ...state,
        getExtInterviewerLoader: false,
        getExtInterviewListStatus: true,
        ExterrorMsg: action.payload,
        ExtinterviewerList: null,
      };
    case actionTypes.GET_EXT_INTERVIEWER_LIST_NETWORK_ERROR:
      return {
        ...state,
        getExtInterviewerLoader: false,
        getExtInterviewListStatus: false,
        ExterrorMsg:
          "Our servers are not responding at the moment, Please bear with us.",
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_INITIAL:
      return {
        ...state,
        interviewerProfileLoader: true,
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_SUCCESS:
      return {
        ...state,
        interviewerProfileLoader: false,
        interviewerProfileStatus: true,
        interviewerProfileData: action.interviewerProfileData,
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_FAIL:
      return {
        ...state,
        interviewerProfileLoader: false,
        interviewerProfileStatus: true,
        interviewerProfileData: null,
        interviewerProfileErrorMsg: action.payload,
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_NETWORK_ERROR:
      return {
        ...state,
        interviewerProfileLoader: false,
        interviewerProfileStatus: false,
        interviewerProfileErrorMsg: "Network Error !! Some things went Wrong",
      };

    //SChedule Interview Step 4 Atishay Start
    case actionTypes.SCHEDULE_INTERVIEW_PROFILE_INITIAL:
      return {
        ...state,
        scheduleInterviewLoader: true,
        scheduleInterviewErrorMsg: "",
        scheduleInterviewEStatus: false,
        scheduleInterviewInterviewerNodata: false,
      };
    case actionTypes.SCHEDULE_INTERVIEW_PROFILE_SUCCESS:
      return {
        ...state,
        scheduleInterviewLoader: false,
        scheduleInterviewInterviewerList: action.payload,
        scheduleInterviewErrorMsg: "",
        scheduleInterviewEStatus: true,
        scheduleInterviewInterviewerNodata: false,
      };
    case actionTypes.SCHEDULE_INTERVIEW_PROFILE_FAIL:
      return {
        ...state,
        scheduleInterviewLoader: false,
        scheduleInterviewEStatus: false,
        scheduleInterviewErrorMsg: action.payload,
        scheduleInterviewInterviewerNodata: true,
      };
    case actionTypes.SCHEDULE_INTERVIEW_PROFILE_ERROR:
      return {
        ...state,
        scheduleInterviewLoader: false,
        scheduleInterviewEStatus: false,
        scheduleInterviewErrorMsg: "No Internet Connection",
        scheduleInterviewInterviewerNodata: false,
      };
    //Schedule Interview Step 4 Atishay Ends
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_INITIAL:
      return {
        ...state,
        interviewerProfileLoader: true,
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_SUCCESS:
      return {
        ...state,
        interviewerProfileLoader: false,
        interviewerProfileStatus: true,
        interviewerProfileData: action.interviewerProfileData,
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_FAIL:
      return {
        ...state,
        interviewerProfileLoader: false,
        interviewerProfileStatus: true,
        interviewerProfileData: null,
        interviewerProfileErrorMsg: action.payload,
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_NETWORK_ERROR:
      return {
        ...state,
        interviewerProfileLoader: false,
        interviewerProfileStatus: false,
        interviewerProfileErrorMsg: "Network Error !! Some things went Wrong",
      };

    case actionTypes.NEW_SAVE_INTERVIEWER_RATING_INITIATE:
      return {
        ...state,
        saveInterviewerRatingLoader: true,
      };
    case actionTypes.NEW_SAVE_INTERVIEWER_RATING_SUCCESS:
      return {
        ...state,
        saveInterviewerRatingLoader: false,
        saveInterviewerRatingStatus: true,
      };
    case actionTypes.NEW_SAVE_INTERVIEWER_RATING_FAIL:
      return {
        ...state,
        saveInterviewerRatingLoader: false,
        saveInterviewerRatingStatus: true,
        saveInterviewerRatingErrorMsg: action.payload,
      };
    case actionTypes.NEW_SAVE_INTERVIEWER_RATING_NETWORK_ERROR:
      return {
        ...state,
        saveInterviewerRatingLoader: false,
        saveInterviewerRatingStatus: false,
        saveInterviewerRatingErrorMsg:
          "Network Error !! Some things went Wrong",
      };

    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_INITIAL:
      return {
        ...state,
        interviewerProfileLoader: true,
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_SUCCESS:
      return {
        ...state,
        interviewerProfileLoader: false,
        interviewerProfileStatus: true,
        interviewerProfileData: action.interviewerProfileData,
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_FAIL:
      return {
        ...state,
        interviewerProfileLoader: false,
        interviewerProfileStatus: true,
        interviewerProfileData: null,
        interviewerProfileErrorMsg: action.payload,
      };
    case actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_NETWORK_ERROR:
      return {
        ...state,
        interviewerProfileLoader: false,
        interviewerProfileStatus: false,
        interviewerProfileErrorMsg: "Network Error !! Some things went Wrong",
      };

    case actionTypes.SAVE_INTERVIEWER_RATING_INITIAL:
      return {
        ...state,
        saveInterviewerRatingLoader: true,
      };
    case actionTypes.SAVE_INTERVIEWER_RATING_SUCCESS:
      return {
        ...state,
        saveInterviewerRatingLoader: false,
        saveInterviewerRatingStatus: true,
      };
    case actionTypes.SAVE_INTERVIEWER_RATING_FAIL:
      return {
        ...state,
        saveInterviewerRatingLoader: false,
        saveInterviewerRatingStatus: true,
        saveInterviewerRatingErrorMsg: action.payload,
      };
    case actionTypes.SAVE_INTERVIEWER_RATING_NETWORK_ERROR:
      return {
        ...state,
        saveInterviewerRatingLoader: false,
        saveInterviewerRatingStatus: false,
        saveInterviewerRatingErrorMsg:
          "Network Error !! Some things went Wrong",
      };

    case actionTypes.GET_CANDIDATE_FEEDBACK_INITIAL:
      return {
        ...state,
        feedbackLoader: true,
        feedBackErr: false,
      };
    case actionTypes.GET_CANDIDATE_FEEDBACK_SUCCESS:
      return {
        ...state,
        feedbackLoader: false,
        feedBackErr: false,
        candidateFeedback: action.payload,
        interviewFeedback: action.payload.interviewFeedback,
        skillRating: action.payload.interviewFeedback.skillRating,
      };

    case actionTypes.GET_CANDIDATE_FEEDBACK_FAIL:
      return {
        ...state,
        feedbackLoader: false,
        feedBackErr: true,
      };
    case actionTypes.GET_CANDIDATE_FEEDBACK_ERROR_FALSE:
      return {
        ...state,
        feedbackLoader: false,
        feedBackErr: false,
      };

    case actionTypes.OPEN_CV_INITIAL:
      return {
        ...state,
        openCvLoader: true,
      };
    case actionTypes.OPEN_CV_SUCCESS:
      return {
        ...state,
        openCvLoader: false,
        openCvStatus: true,
        cvData: action.cvData,
      };
    case actionTypes.OPEN_CV_FAIL:
      return {
        ...state,
        openCvLoader: false,
        openCvStatus: true,
        openCvErrorMsg: action.openCvErrorMsg,
        openCvSuggestion: action.suggestion,
        cvData: null,
      };
    case actionTypes.OPEN_CV_NETWORK_ERROR:
      return {
        ...state,
        openCvLoader: false,
        openCvStatus: false,
        openCvErrorMsg: "Network Error !! Some things went Wrong",
      };
    case actionTypes.CANDIDATE_DOWNLOAD_FILE_INITIAL:
      return {
        ...state,
        candidate_download_loader: true,
        candidate_download_status: false,
        candidate_cv_data: null,
        candidate_download_err_msg: "",
      };
    case actionTypes.CANDIDATE_DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        candidate_download_loader: false,
        candidate_download_status: true,
        candidate_cv_data: action.cvData,
        candidate_download_err_msg: "",
      };
    case actionTypes.CANDIDATE_DOWNLOAD_FILE_FAIL:
      return {
        ...state,
        candidate_download_loader: false,
        candidate_download_status: false,
        candidate_cv_data: null,
        candidate_download_err_msg: action.openCvErrorMsg,
      };

    case actionTypes.INTERVIEWER_FORGOT_PASSWORD_INITIAL:
      return {
        ...state,
        resetLinkErrorMsg: "",
        emailLinkSentLoader: true,
      };
    case actionTypes.INTERVIEWER_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        emailLinkSentSuccess: true,
        resetLinkErrorMsg: "",
        emailLinkSentLoader: false,
        emailForgot: action.email,
      };
    case actionTypes.INTERVIEWER_FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        emailLinkSentSuccess: false,
        resetLinkErrorMsg: action.payload,
        emailLinkSentLoader: false,
      };

    case actionTypes.INTERVIEWER_FORGOT_PASSWORD_NETWORK_ERROR:
      return {
        ...state,
        interviewerLoader: false,
        interviewerApiStatus: false,
        interviewerErrorMsg: "Network Error !! Some things went Wrong",
      };
    case actionTypes.VERIFY_INTERVIEWER_EMAIL_INITIAL:
      return {
        ...state,
        loader: true,
        verifyEmailStatus: false,
      };
    case actionTypes.VERIFY_INTERVIEWER_EMAIL_SUCCESS:
      return {
        ...state,
        loader: false,
        verifyEmailStatus: action.payload,
      };
    case actionTypes.VERIFY_INTERVIEWER_EMAIL_FAIL:
      return {
        ...state,
        loader: false,
        verifyEmailStatus: action.payload,
      };

    case actionTypes.RESEND_OTP_INITIAL:
      return {
        ...state,
        resendotpLoader: true,
        otpSent: null,
        mobileLastFourDigit: "",
        resendotpApiStatus: false,
        verifyotpAtloginerrorMsg: "",
        resentOtp: false,
      };
    case actionTypes.RESEND_OTP_SUCCESS:
      return {
        ...state,
        resendotpLoader: false,
        resentOtp: true,
        otpSent: action.otpSent,
        mobileLastFourDigit: action.mobileLastFourDigit,
        resendotpApiStatus: true,
      };
    case actionTypes.RESEND_OTP_FAIL:
      return {
        ...state,
        resendotpLoader: false,
        otpSent: null,
        mobileLastFourDigit: "",
        resendotpApiStatus: true,
        resentOtp: false,
      };
    case actionTypes.RESEND_OTP_NETWORK_ERROR:
      return {
        ...state,
        resentNetworkError: true,
      };

    case actionTypes.VERIFY_OTP_AT_LOGIN_INITIAL:
      return {
        ...state,
        verifyotpAtloginLoader: true,
        verifyotpAtloginApiStatus: false,
        verifyotpAtloginNetworkError: false,
        verifyotpAtloginerrorMsg: "",
        otpSent: false,
      };
    case actionTypes.VERIFY_OTP_AT_LOGIN_SUCCESS:
      return {
        ...state,
        verifyotpAtloginLoader: false,
        verifyotpAtloginApiStatus: true,
        verifyotpAtloginNetworkError: false,
        verifyotpAtloginerrorMsg: "",
      };
    case actionTypes.VERIFY_OTP_AT_LOGIN_FAIL:
      return {
        ...state,
        verifyotpAtloginLoader: false,
        verifyotpAtloginApiStatus: false,
        verifyotpAtloginNetworkError: false,
        verifyotpAtloginerrorMsg: action.verifyerrmsg,
      };
    case actionTypes.VERIFY_OTP_AT_LOGIN_NETWORK_ERROR:
      return {
        ...state,
        verifyotpAtloginLoader: false,
        verifyotpAtloginApiStatus: false,
        verifyotpAtloginNetworkError: true,
        verifyotpAtloginerrorMsg: "",
      };

    case actionTypes.RESEND_INTERVIEWER_EMAIL_INITIAL:
      return {
        ...state,
        resendInterviewerEmailStatus: false,
        resendInterviewerEmailLoader: true,
      };
    case actionTypes.RESEND_INTERVIEWER_EMAIL_SUCCESS:
      return {
        ...state,
        resendInterviewerEmailStatus: action.payload,
        resendInterviewerEmailLoader: false,
      };
    case actionTypes.RESEND_INTERVIEWER_EMAIL_FAIL:
      return {
        ...state,
        resendInterviewerEmailStatus: action.payload,
        resendInterviewerEmailLoader: false,
      };

    case actionTypes.ADMIN_INTERVIEW_LIST_INITIATE:
      return {
        ...state,
        InterviewPaymentListLoader: true,
        InterviewPaymentListData: null,
        InterviewPaymentListNetworkError: false,
        InterviewPaymentListError: false,
        InterviewPaymentListErrorMsg: null,
      };
    case actionTypes.ADMIN_INTERVIEW_LIST_SUCCESS:
      return {
        ...state,
        InterviewPaymentListLoader: false,
        InterviewPaymentListData: action.interviewList,
        InterviewPagination: action.InterviewPagination,
        InterviewPaymentListNetworkError: false,
        InterviewPaymentListError: false,
        InterviewPaymentListErrorMsg: null,
      };
    case actionTypes.ADMIN_INTERVIEW_LIST_FAIL:
      return {
        ...state,
        InterviewPaymentListLoader: false,
        InterviewPaymentListData: null,
        InterviewPaymentListNetworkError: false,
        InterviewPaymentListError: true,
        InterviewPaymentListErrorMsg: action.interviewErrorMsg,
      };
    case actionTypes.ADMIN_INTERVIEW_LIST_NETWORK_ERROR:
      return {
        ...state,
        InterviewPaymentListLoader: false,
        InterviewPaymentListData: null,
        InterviewPaymentListNetworkError: true,
        InterviewPaymentListError: true,
        InterviewPaymentListErrorMsg:
          "Our servers are not responding at the moment, Please bear with us.",
      };

    case actionTypes.MAKE_PAYMENT_INITIATE:
      return {
        ...state,
        InterviewPaymentListLoader: true,
        MakePaymentData: null,
        MakePaymentNetworkError: false,
        MakePaymentError: false,
        MakePaymentErrorMsg: null,
      };
    case actionTypes.MAKE_PAYMENT_SUCCESS:
      return {
        ...state,
        InterviewPaymentListLoader: false,
        MakePaymentData: action.payload,
        MakePaymentNetworkError: false,
        MakePaymentError: false,
        MakePaymentErrorMsg: null,
      };
    case actionTypes.MAKE_PAYMENT_FAIL:
      return {
        ...state,
        InterviewPaymentListLoader: false,
        MakePaymentData: null,
        MakePaymentNetworkError: false,
        MakePaymentError: true,
        MakePaymentErrorMsg: action.payload,
      };
    case actionTypes.MAKE_PAYMENT_NETWORK_ERROR:
      return {
        ...state,
        InterviewPaymentListLoader: false,
        MakePaymentData: null,
        MakePaymentNetworkError: true,
        MakePaymentError: true,
        MakePaymentErrorMsg:
          "Our servers are not responding at the moment, Please bear with us.",
      };

    case actionTypes.ADMIN_PAYMENT_INITIATE:
      return {
        ...state,
        paymentInitiateLoader: true,
        paymentInitiateData: null,
        paymentInitiateNetworkError: false,
        paymentInitiateError: false,
        paymentInitiateErrorMsg: null,
      };
    case actionTypes.ADMIN_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentInitiateLoader: false,
        paymentInitiateData: action.payload,
        paymentInitiateNetworkError: false,
        paymentInitiateError: false,
        paymentInitiateErrorMsg: null,
      };
    case actionTypes.ADMIN_PAYMENT_FAIL:
      return {
        ...state,
        paymentInitiateLoader: false,
        paymentInitiateData: null,
        paymentInitiateNetworkError: false,
        paymentInitiateError: true,
        paymentInitiateErrorMsg: action.payload,
      };
    case actionTypes.ADMIN_PAYMENT_NETWORK_ERROR:
      return {
        ...state,
        paymentInitiateLoader: false,
        paymentInitiateData: null,
        paymentInitiateNetworkError: true,
        paymentInitiateError: true,
        paymentInitiateErrorMsg: action.payload,
      };

    case actionTypes.ADMIN_INTERVIEW_LIST_INITIATE:
      return {
        ...state,
        InterviewPaymentListLoader: true,
        InterviewPaymentListData: null,
        InterviewPaymentListNetworkError: false,
        InterviewPaymentListError: false,
        InterviewPaymentListErrorMsg: null,
      };
    case actionTypes.ADMIN_INTERVIEW_LIST_SUCCESS:
      return {
        ...state,
        InterviewPaymentListLoader: false,
        InterviewPaymentListData: action.interviewList,
        InterviewPaymentListNetworkError: false,
        InterviewPaymentListError: false,
        InterviewPaymentListErrorMsg: null,
      };
    case actionTypes.ADMIN_INTERVIEW_LIST_FAIL:
      return {
        ...state,
        InterviewPaymentListLoader: false,
        InterviewPaymentListData: null,
        InterviewPaymentListNetworkError: false,
        InterviewPaymentListError: true,
        InterviewPaymentListErrorMsg: action.interviewErrorMsg,
      };
    case actionTypes.ADMIN_INTERVIEW_LIST_NETWORK_ERROR:
      return {
        ...state,
        InterviewPaymentListLoader: false,
        InterviewPaymentListData: null,
        InterviewPaymentListNetworkError: true,
        InterviewPaymentListError: true,
        InterviewPaymentListErrorMsg: "Network Error",
      };
    case actionTypes.EMPLOYER_CANCEL_INTERVIEW_INITIATE:
      return {
        ...state,
        getInterviewListLoader: true,
        cancelInterviewError: false,
        cancelInterviewSuccess: false,
      };
    case actionTypes.EMPLOYER_CANCEL_INTERVIEW_SUCCESS:
      return {
        ...state,
        getInterviewListLoader: false,
        cancelInterviewSuccess: true,
      };
    case actionTypes.EMPLOYER_CANCEL_INTERVIEW_FAIL:
      return {
        ...state,
        cancelInterviewError: true,
        cancelInterviewErrorMsg: action.payload,
        getInterviewListLoader: false,
      };
    case actionTypes.EMPLOYER_CANCEL_INTERVIEW_NETWORK_ERROR:
      return {
        ...state,
        getInterviewListLoader: false,
        cancelInterviewError: false,
      };
    case actionTypes.GET_CANDIDATE_MULTIPLE_FEEDBACKS_INITIAL:
      return {
        ...state,
        feedbackLoader: true,
        candidateMultipleFeedbacksError: false,
      };
    case actionTypes.GET_CANDIDATE_MULTIPLE_FEEDBACKS_SUCCESS:
      return {
        ...state,
        feedbackLoader: false,
        candidateMultipleFeedbacksList: action.payload,
      };
    case actionTypes.GET_CANDIDATE_MULTIPLE_FEEDBACKS_FAIL:
      return {
        ...state,
        feedbackLoader: false,
        candidateMultipleFeedbacksError: true,
        candidateMultipleFeedbacksErrorMsg: action.payload,
      };
    case actionTypes.GET_CANDIDATE_MULTIPLE_FEEDBACKS_NETWORK_ERROR:
      return {
        ...state,
        feedbackLoader: false,
        candidateMultipleFeedbacksError: false,
      };
    case actionTypes.SECURITY_DEPOSIT_PAYMENT_INITIATE:
      return {
        ...state,
        loader: true,
        securityDepositErr: false,
        securityDepositServerErr: false,
      };
    case actionTypes.SECURITY_DEPOSIT_PAYMENT_SUCCESS:
      return {
        ...state,
        encRequest: action.payload.encRequest,
        access_code: action.payload.access_code,
        orderId: action.payload.orderId,
        loader: true,
      };
    case actionTypes.SECURITY_DEPOSIT_PAYMENT_FAIL:
      return {
        ...state,
        loader: false,
        securityDepositErr: true,
        securityDepositErrMsg: action.payload,
      };
    case actionTypes.SECURITY_DEPOSIT_PAYMENT_NETWORK_ERROR:
      return {
        ...state,
        loader: false,
        securityDepositServerErr: true,
        securityDepositErr: false,
      };

    case actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_INITIATE:
      return {
        ...state,
        paymentfornonadminLoader: true,
        paymentfornonadminApiStatus: false,
        paymentfornonadminTotalcount: "",
        paymentfornonadminpaymentListData: null,
        paymentListDataNetworkError: false,
      };
    case actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_SUCCESS:
      return {
        ...state,
        paymentfornonadminLoader: false,
        paymentfornonadminApiStatus: true,
        paymentfornonadminTotalcount: action.totalCount,
        paymentfornonadminpaymentListData: action.paymentListData,
        paymentListDataNetworkError: false,
      };
    case actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_FAIL:
      return {
        ...state,
        paymentfornonadminLoader: false,
        paymentfornonadminApiStatus: false,
        paymentfornonadminTotalcount: "",
        paymentfornonadminpaymentListData: null,
        paymentListDataNetworkError: false,
      };
    case actionTypes.GET_INTERVIEWLIST_FORPAYMENT_NONADMIN_NETWORK_ERROR:
      return {
        ...state,
        paymentfornonadminLoader: false,
        paymentfornonadminApiStatus: false,
        paymentfornonadminTotalcount: "",
        paymentfornonadminpaymentListData: null,
        paymentListDataNetworkError: true,
      };
    case actionTypes.CHECK_INTERVIEW_SCHEDULE_BALANCE_INITIATE:
      return {
        ...state,
        checkBalanceLoader: true,
        checkInterviewBalanceError: false,
        checkInterviewBalanceNetworkError: false,
      };
    case actionTypes.CHECK_INTERVIEW_SCHEDULE_BALANCE_SUCCESS:
      return {
        ...state,
        checkBalanceLoader: false,
        sufficientBalance: action.payload.interviewBalanceSuffient,
        remainingBalance: action.payload.remainingBalance,
      };
    case actionTypes.CHECK_INTERVIEW_SCHEDULE_BALANCE_FAIL:
      return {
        ...state,
        checkBalanceLoader: false,
        checkInterviewBalanceError: true,
        checkInterviewBalanceErrorMsg: action.payload,
        checkInterviewBalanceNetworkError: false,
      };
    case actionTypes.CHECK_INTERVIEW_SCHEDULE_BALANCE_NETWORK_ERROR:
      return {
        ...state,
        checkBalanceLoader: false,
        checkInterviewBalanceError: false,
        checkInterviewBalanceNetworkError: true,
      };
    case actionTypes.CONFIRM_PAYMENT_STATUS_INITIATE:
      return {
        ...state,
        confirmPaymentLoader: true,
        confirmPaymentError: false,
        confirmPaymentNetworkError: false,
      };
    case actionTypes.CONFIRM_PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        confirmPaymentLoader: false,
        confirmPaymentError: false,
        confirmPaymentStatusData: action.payload,
      };
    case actionTypes.CONFIRM_PAYMENT_STATUS_FAIL:
      return {
        ...state,
        confirmPaymentLoader: false,
        confirmPaymentError: true,
        confrimPaymentErrorMsg: action.payload,
      };
    case actionTypes.CONFIRM_PAYMENT_STATUS_NETWORK_ERROR:
      return {
        ...state,
        confirmPaymentLoader: false,
        confirmPaymentError: false,
        confirmPaymentNetworkError: true,
      };
    case actionTypes.PAYMENT_INVOICE_LIST_INITIATE:
      return {
        ...state,
        PaymentInvoiceListLoader: true,
        PaymentInvoiceListData: null,
        PaymentInvoiceListNetworkError: false,
        PaymentInvoiceListError: false,
        PaymentInvoiceListErrorMsg: null,
      };
    case actionTypes.PAYMENT_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        PaymentInvoiceListLoader: false,
        PaymentInvoiceListData: action.invoiceList,
        PaymentInvoiceListNetworkError: false,
        PaymentInvoiceListError: false,
        PaymentInvoiceListErrorMsg: null,
      };
    case actionTypes.PAYMENT_INVOICE_LIST_FAIL:
      return {
        ...state,
        PaymentInvoiceListLoader: false,
        PaymentInvoiceListData: null,
        PaymentInvoiceListNetworkError: false,
        PaymentInvoiceListError: true,
        PaymentInvoiceListErrorMsg: action.invoiceErrorMsg,
      };
    case actionTypes.PAYMENT_INVOICE_LIST_NETWORK_ERROR:
      return {
        ...state,
        PaymentInvoiceListLoader: false,
        PaymentInvoiceListData: null,
        PaymentInvoiceListNetworkError: true,
        PaymentInvoiceListError: true,
        PaymentInvoiceListErrorMsg:
          "Our servers are not responding at the moment, Please bear with us.",
      };
    case actionTypes.PAYMENT_INVOICE_DETAILS_INITIATE:
      return {
        ...state,
        PaymentInvoiceDetailsLoader: true,
        PaymentInvoiceDetailsData: null,
        PaymentInvoiceDetailsNetworkError: false,
        PaymentInvoiceDetailsError: false,
        PaymentInvoiceDetailsErrorMsg: null,
      };
    case actionTypes.PAYMENT_INVOICE_DETAILS_SUCCESS:
      return {
        ...state,
        PaymentInvoiceDetailsLoader: false,
        PaymentInvoiceDetailsData: action.invoiceDetails,
        PaymentInvoiceDetailsNetworkError: false,
        PaymentInvoiceDetailsError: false,
        PaymentInvoiceDetailsErrorMsg: null,
      };
    case actionTypes.PAYMENT_INVOICE_DETAILS_FAIL:
      return {
        ...state,
        PaymentInvoiceDetailsLoader: false,
        PaymentInvoiceDetailsData: null,
        PaymentInvoiceDetailsNetworkError: false,
        PaymentInvoiceDetailsError: true,
        PaymentInvoiceDetailsErrorMsg: action.interviewErrorMsg,
      };
    case actionTypes.PAYMENT_INVOICE_DETAILS_NETWORK_ERROR:
      return {
        ...state,
        PaymentInvoiceDetailsLoader: false,
        PaymentInvoiceDetailsData: null,
        PaymentInvoiceDetailsNetworkError: true,
        PaymentInvoiceDetailsError: true,
        PaymentInvoiceDetailsErrorMsg: "Network Error",
      };

    case actionTypes.PAYMENT_INVOICE_DETAILS_RESET_STATE:
      return {
        ...state,
        PaymentInvoiceDetailsLoader: false,
        PaymentInvoiceDetailsData: null,
        PaymentInvoiceDetailsNetworkError: false,
        PaymentInvoiceDetailsError: false,
        PaymentInvoiceDetailsErrorMsg: null,
      };

    case actionTypes.ORDER_HISTORY_INITIATE:
      return {
        ...state,
        loader: true, // loader Used here is for security deposit Payment as for two component in the same page
        OrderHistoryData: null,
        OrderHistoryNetworkError: false,
        OrderHistoryError: false,
        OrderHistoryErrorMsg: null,
      };
    case actionTypes.ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        loader: false,
        OrderHistoryData: action.orderData,
        OrderHistoryNetworkError: false,
        OrderHistoryError: false,
        OrderHistoryErrorMsg: null,
      };
    case actionTypes.ORDER_HISTORY_FAIL:
      return {
        ...state,
        loader: false,
        OrderHistoryData: null,
        OrderHistoryNetworkError: false,
        OrderHistoryError: true,
        OrderHistoryErrorMsg: action.interviewErrorMsg,
      };
    case actionTypes.ORDER_HISTORY_NETWORK_ERROR:
      return {
        ...state,
        loader: false,
        OrderHistoryData: null,
        OrderHistoryNetworkError: true,
        OrderHistoryError: true,
        OrderHistoryErrorMsg: "Network Error",
      };

    case actionTypes.APPROVE_PAYMENT_BYNONADMIN_INITIATE:
      return {
        ...state,
        approvepaymentLoader: true,
        approvepaymentNetworkError: false,
        approvepaymentApistatus: false,
        approvepaymentData: "",
      };
    case actionTypes.APPROVE_PAYMENT_BYNONADMIN_SUCCESS:
      return {
        ...state,
        approvepaymentLoader: false,
        approvepaymentNetworkError: false,
        approvepaymentApistatus: true,
        approvepaymentData: "",
      };
    case actionTypes.APPROVE_PAYMENT_BYNONADMIN_FAIL:
      return {
        ...state,
        approvepaymentLoader: false,
        approvepaymentNetworkError: false,
        approvepaymentApistatus: false,
        approvepaymentData: "",
      };
    case actionTypes.APPROVE_PAYMENT_BYNONADMIN_NETWORK_ERROR:
      return {
        ...state,
        approvepaymentLoader: true,
        approvepaymentNetworkError: true,
        approvepaymentApistatus: false,
        approvepaymentData: "",
      };

    case actionTypes.GET_INVOICE_DETAILS_BEFORE_PAYMENT_INITIATE:
      return {
        ...state,
        beforepaymentinvoiceLoader: true,
        beforepaymentinvoiceNetworkError: false,
        beforepaymentinvoiceApistatus: false,
        beforepaymentinvoiceData: "",
      };
    case actionTypes.GET_INVOICE_DETAILS_BEFORE_PAYMENT_SUCCESS:
      return {
        ...state,
        beforepaymentinvoiceLoader: false,
        beforepaymentinvoiceNetworkError: false,
        beforepaymentinvoiceApistatus: true,
        beforepaymentinvoiceData: action.invoiceDetails,
      };
    case actionTypes.GET_INVOICE_DETAILS_BEFORE_PAYMENT_FAIL:
      return {
        ...state,
        beforepaymentinvoiceLoader: false,
        beforepaymentinvoiceNetworkError: false,
        beforepaymentinvoiceApistatus: false,
        beforepaymentinvoiceData: "",
      };
    case actionTypes.GET_INVOICE_DETAILS_BEFORE_PAYMENT_NETWORK_ERROR:
      return {
        ...state,
        beforepaymentinvoiceLoader: false,
        beforepaymentinvoiceNetworkError: true,
        beforepaymentinvoiceApistatus: false,
        beforepaymentinvoiceData: "",
      };

    case actionTypes.GET_INTERVIEWER_AVAILABLE_SLOTS_INITIATE:
      return {
        ...state,
        availableSlotLoader: true,
        availableSlotData: null,
        availableSlotNetworkError: false,
        availableSlotError: false,
        availableSlotErrorMsg: null,
      };
    case actionTypes.GET_INTERVIEWER_AVAILABLE_SLOTS_SUCCESS:
      return {
        ...state,
        availableSlotLoader: false,
        availableSlotData: action.availableSlot,
        availableSlotNetworkError: false,
        availableSlotError: false,
        availableSlotErrorMsg: null,
      };
    case actionTypes.GET_INTERVIEWER_AVAILABLE_SLOTS_FAIL:
      return {
        ...state,
        availableSlotLoader: false,
        availableSlotData: null,
        availableSlotNetworkError: false,
        availableSlotError: true,
        availableSlotErrorMsg: action.availableSlotError,
      };
    case actionTypes.GET_INTERVIEWER_AVAILABLE_SLOTS_NETWORK_ERROR:
      return {
        ...state,
        availableSlotLoader: false,
        availableSlotData: null,
        availableSlotNetworkError: true,
        availableSlotError: false,
        availableSlotErrorMsg: null,
      };

    case actionTypes.EMPLOYER_LOGED_RESET_PASSWORD_INITIAL:
      return {
        ...state,
        empresetLoader: true,
        empresetSuccess: false,
        empresetErrorMsg: null,
      };
    case actionTypes.EMPLOYER_LOGED_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        empresetSuccess: true,
        empresetLoader: false,
        empresetErrorMsg: null,
      };
    case actionTypes.EMPLOYER_LOGED_RESET_PASSWORD_FAIL:
      return {
        ...state,
        empresetErrorMsg: action.payload,
        empresetLoader: false,
        empresetSuccess: false,
      };
    case actionTypes.NOTIFY_FOXMATRIX_INITIATE:
      return {
        ...state,
        notifyFoxmatrixLoader: true,
        notifyFoxmatrixSuceess: false,
        notifyFoxmatrixFailMsg: false,
        notifyFoxmatrixNetworkError: false,
      };
    case actionTypes.NOTIFY_FOXMATRIX_SUCCESS:
      return {
        ...state,
        notifyFoxmatrixLoader: false,
        notifyFoxmatrixSuceess: action.payload,
        notifyFoxmatrixFailMsg: false,
        notifyFoxmatrixNetworkError: false,
      };
    case actionTypes.NOTIFY_FOXMATRIX_FAIL:
      return {
        ...state,
        notifyFoxmatrixLoader: false,
        notifyFoxmatrixSuceess: false,
        notifyFoxmatrixFailMsg: action.payload,
        notifyFoxmatrixNetworkError: null,
      };
    case actionTypes.NOTIFY_FOXMATRIX_NETWORK_ERROR:
      return {
        ...state,
        notifyFoxmatrixLoader: false,
        notifyFoxmatrixSuceess: false,
        notifyFoxmatrixFailMsg: null,
        notifyFoxmatrixNetworkError: action.payload,
      };
    case actionTypes.CLEAR_STATE_NOTIFY:
      return {
        ...state,
        notifyFoxmatrixLoader: false,
        notifyFoxmatrixSuceess: false,
        notifyFoxmatrixFailMsg: false,
        notifyFoxmatrixNetworkError: false,
      };

    case actionTypes.VIEW_INTERVIEW_DETAILS_INITIATE:
      return {
        ...state,
        viewInterviewDetailsLoader: true,
        viewInterviewDetailsData: null,
        viewInterviewDetailsFailMsg: false,
        viewInterviewDetailsNetworkError: false,
      };
    case actionTypes.VIEW_INTERVIEW_DETAILS_SUCCESS:
      return {
        ...state,
        viewInterviewDetailsLoader: false,
        viewInterviewDetailsData: action.viewInterviewDetailsData,
        viewInterviewDetailsFailMsg: false,
        viewInterviewDetailsNetworkError: false,
      };
    case actionTypes.VIEW_INTERVIEW_DETAILS_FAIL:
      return {
        ...state,
        viewInterviewDetailsLoader: false,
        viewInterviewDetailsSuceess: null,
        viewInterviewDetailsFailMsg: true,
        viewInterviewDetailsNetworkError: null,
      };
    case actionTypes.VIEW_INTERVIEW_DETAILS_NETWORK_ERROR:
      return {
        ...state,
        viewInterviewDetailsLoader: false,
        viewInterviewDetailsSuceess: null,
        viewInterviewDetailsFailMsg: false,
        viewInterviewDetailsNetworkError: true,
      };

    case actionTypes.GET_INTERVIEWER_TIME_SLOTS_INITIAL:
      return {
        ...state,
        getInterviewerTimeSlotsLoader: true,
        myScheduleTimingResponseList: null,
        interviewerAvailableSlotResponseList: null,
        getInterviewerTimeSlotsFailMsg: false,
        getInterviewerTimeSlotsNetworkError: false,
      };
    case actionTypes.GET_INTERVIEWER_TIME_SLOTS_SUCCESS:
      return {
        ...state,
        getInterviewerTimeSlotsLoader: false,
        myScheduleTimingResponseList: action.myScheduleTimingResponseList,
        interviewerAvailableSlotResponseList:
          action.interviewerAvailableSlotResponseList,
        getInterviewerTimeSlotsFailMsg: false,
        getInterviewerTimeSlotsNetworkError: false,
      };
    case actionTypes.GET_INTERVIEWER_TIME_SLOTS_FAIL:
      return {
        ...state,
        getInterviewerTimeSlotsLoader: false,
        getInterviewerTimeSlotsSuceess: null,
        getInterviewerTimeSlotsFailMsg: true,
        getInterviewerTimeSlotsNetworkError: null,
      };
    case actionTypes.GET_INTERVIEWER_TIME_SLOTS_NETWORK_ERROR:
      return {
        ...state,
        getInterviewerTimeSlotsLoader: false,
        getInterviewerTimeSlotsSuceess: null,
        getInterviewerTimeSlotsFailMsg: false,
        getInterviewerTimeSlotsNetworkError: true,
      };

    case actionTypes.UPDATED_MOBILE_INITIAL:
      return {
        ...state,
        mobileUpdated: null,
        mobileUpdatedError: null,
        mobileUpdatedLoader: true,
      };
    case actionTypes.UPDATED_MOBILE_SUCCESS:
      return {
        ...state,
        mobileUpdated: true,
        mobileUpdatedLoader: false,
      };
    case actionTypes.UPDATED_MOBILE_FAIL:
      return {
        ...state,
        mobileUpdated: false,
        mobileUpdatedError: true,
        mobileUpdatedLoader: false,
      };
    case actionTypes.UPDATED_OTP_INITIAL:
      return {
        ...state,
        otpUpdated: null,
        otpUpdatedError: null,
        mobileUpdatedLoader: true,
      };
    case actionTypes.UPDATED_OTP_SUCCESS:
      return {
        ...state,
        otpUpdated: true,
        otpUpdatedLoader: false,
        mobileUpdatedLoader: false,
      };
    case actionTypes.UPDATED_OTP_FAIL:
      return {
        ...state,
        otpUpdated: false,
        otpUpdatedError: true,
        mobileUpdatedLoader: false,
      };
    case actionTypes.UPDATED_NAME_INITIAL:
      return {
        ...state,
        nameUpdated: null,
        nameUpdatedError: null,
      };
    case actionTypes.UPDATED_NAME_SUCCESS:
      return {
        ...state,
        nameUpdated: true,
      };
    case actionTypes.UPDATED_NAME_FAIL:
      return {
        ...state,
        nameUpdated: false,
        nameUpdatedError: true,
      };
    case actionTypes.RESET_VERIFY_STATE:
      return {
        ...state,
        mobileUpdated: null,
        mobileUpdatedError: null,
        otpUpdated: null,
        otpUpdatedError: null,
        nameUpdated: null,
        nameUpdatedError: null,
      };
    case actionTypes.OTP_UPDATED_RESET:
      return {
        ...state,
        otpUpdated: null,
        mobileUpdated: null,
      };
    case actionTypes.CREDIT_BALANCE_INITIAL:
      return {
        ...state,
        creditBalance: null,
      };
    case actionTypes.CREDIT_BALANCE_SUCCESS:
      return {
        ...state,
        creditBalance: action.payload,
      };
    case actionTypes.CREDIT_BALANCE_FAIL:
      return {
        ...state,
        creditBalance: "fail",
      };
    case actionTypes.HELP_AND_FEEDBACK_INITIATE:
      return {
        ...state,
        feedbackLoader: true,
      };
    case actionTypes.HELP_AND_FEEDBACK_SUCCESS:
      return {
        ...state,
        feedbackLoader: false,
        formSubmitted: action.payload,
      };
    case actionTypes.HELP_AND_FEEDBACK_FAIL:
      return {
        ...state,
        feedbackLoader: false,
        error: true,
        errMsg: action.payload,
      };
    case actionTypes.HELP_AND_FEEDBACK_NETWORKERROR:
      return {
        ...state,
        feedbackLoader: false,
        error: true,
        errMsg:
          "Our servers are not responding at the moment, Please bear with us.",
      };
    case actionTypes.HELP_AND_FEEDBACK_CLEAR:
      return {
        ...state,
        formSubmitted: undefined,
        error: undefined,
        errMsg: undefined,
      };

    case actionTypes.SAVE_FILTER_VALUE:
      return {
        ...state,
        availabilityFilter: action.payload,
        typeDate: action.typeDate,
      };
    case actionTypes.SAVE_FILTER_VALUE_BY_TIME_SLOT:
      return {
        ...state,
        timeslotFilter: action.payloadTime,
      };
    case actionTypes.SAVE_FILTER_VALUE_BY_NAME:
      return {
        ...state,

        nameFilter: action.payload,
      };
    case actionTypes.CLEAR_ALL_SAVED_FILTER_AT_INTERVIEWER:
      return {
        ...state,
        availabilityFilter: "",
        typeDate: "",
        nameFilter: "",
        timeslotFilter: "",
      };
    case actionTypes.RESET_SIGNUP_STATE:
      return {
        ...state,
        verifyotpAtloginLoader: false,
        verifyotpAtloginApiStatus: false,
        verifyotpAtloginNetworkError: false,
        verifyotpAtloginerrorMsg: "",
        otpSent: false,
      };
    case actionTypes.SCHEDULE_COUNCELLING_INITIAL:
      return {
        ...state,
        scheduleInterviewEStatus: false,
      };
    case actionTypes.SCHEDULE_COUNCELLING_SUCCESS:
      return {
        ...state,
        scheduleInterviewEStatus: true,
      };
    case actionTypes.SCHEDULE_COUNCELLING_FAIL:
      return {
        ...state,
        scheduleInterviewEStatus: false,
      };

    default:
      return state;
  }
};
